import { FC } from 'react';

import { getOpstartDate } from '../../utils/voorraadbeheer';

import VoorraadDots from './VoorraadDots';

import styles from './VoorraadAantal.module.css';

type VoorraadTotaalAantalProps = {
  aantal: number;
  /** Title overwrites all other messages. */
  title?: string;
  matType?: string;
  knoop?: string;
  nvt?: boolean;
  claimsCount?: number;
  /** Getoond ipv `aantal` bij de oranje (matig tekort) categorie: het over/tekort dat opgelost kan worden met claims. */
  overOfTekortMetClaims?: number;
  /** Getoond ipv `aantal` bij de rode (ernstig tekort) categorie. */
  beschikbareReizigersdienst?: number;
};

const useFormatMessage = (aantal: number, matType?: string, knoop?: string): string => {
  const aantalPart = aantal < 0 ? 'tekort' : 'over';
  const aantalPartCapitalize = `${aantalPart.substring(0, 1).toUpperCase()}${aantalPart.substring(1)}`;
  const opstartPart = getOpstartDate();
  if (matType) return `${matType} ${aantalPart} op ${opstartPart}:`;
  if (knoop) return `${aantalPartCapitalize} op ${knoop} op ${opstartPart}:`;
  return `${aantalPartCapitalize} ${opstartPart}:`;
};

const VoorraadTotaalAantal: FC<VoorraadTotaalAantalProps> = ({
  aantal,
  title = undefined,
  matType = undefined,
  knoop = undefined,
  nvt = false,
  claimsCount = 0,
  overOfTekortMetClaims = aantal,
  beschikbareReizigersdienst = aantal,
}) => {
  const message = useFormatMessage(aantal, matType, knoop);

  return (
    <div className={[styles.voorraadTotaalAantal].join(' ')}>
      <div style={{ textWrap: 'nowrap' }}>{title ?? message}</div>
      <VoorraadDots
        aantal={aantal}
        claimsCount={claimsCount}
        overOfTekortMetClaims={overOfTekortMetClaims}
        beschikbareReizigersdienst={beschikbareReizigersdienst}
        nvt={nvt}
        compact
      />
    </div>
  );
};
export default VoorraadTotaalAantal;
